import { useEffect, useState } from "react";
import { useAccessToken } from "@/features/auth/useAccessToken";
import { listConnections, type ConnectionOut } from "@/shared/api/integration";
import { toastApiError } from "@/shared/ui/toast";

/** The caller's connections of one source type (`null` while loading). */
export function useConnectionsOf(sourceType: "blob" | "veeva"): ConnectionOut[] | null {
  const getToken = useAccessToken();
  const [items, setItems] = useState<ConnectionOut[] | null>(null);
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const token = await getToken();
        const page = await listConnections(token, sourceType);
        if (!cancelled) setItems(page.items);
      } catch (err) {
        toastApiError("Could not list connections", err);
        if (!cancelled) setItems([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getToken, sourceType]);
  return items;
}
